/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_InternalInputs */

const en_us2_error_internal = /** @type {(inputs: Error_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong on our side. Please try again.`)
};

const pt_br2_error_internal = /** @type {(inputs: Error_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado do nosso lado. Tente de novo.`)
};

const es_419_error_internal = /** @type {(inputs: Error_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal de nuestro lado. Intenta de nuevo.`)
};

const pt_pt2_error_internal = /** @type {(inputs: Error_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo correu mal do nosso lado. Tenta outra vez.`)
};

const fr_fr2_error_internal = /** @type {(inputs: Error_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un problème est survenu de notre côté. Réessaie.`)
};

const de_de2_error_internal = /** @type {(inputs: Error_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei uns ist etwas schiefgelaufen. Versuch es bitte noch mal.`)
};

const it_it2_error_internal = /** @type {(inputs: Error_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa è andato storto da parte nostra. Riprova.`)
};

/**
* | output |
* | --- |
* | "Something went wrong on our side. Please try again." |
*
* @param {Error_InternalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const error_internal = /** @type {((inputs?: Error_InternalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_InternalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_error_internal(inputs)
	if (locale === "es-419") return es_419_error_internal(inputs)
	if (locale === "pt-PT") return pt_pt2_error_internal(inputs)
	if (locale === "fr-FR") return fr_fr2_error_internal(inputs)
	if (locale === "de-DE") return de_de2_error_internal(inputs)
	if (locale === "it-IT") return it_it2_error_internal(inputs)
	return en_us2_error_internal(inputs)
});
export { error_internal as "error.internal" }